/* Exclusive price upsell popup: intercepts a product's Add to Cart click and
   offers discounted add-on products before the item(s) actually get added.
   Contents are variant-specific and get rebuilt on theme:variant:change, since
   swapping a variant on the PDP updates the form without reloading the page. */
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-exclusive-upsell-popup]');
  if (!popup) return;

  var formId = popup.getAttribute('data-atc-form-id');
  var form = formId ? document.getElementById(formId) : null;
  var atcButton = form ? form.querySelector('[data-add-to-cart]') : null;
  if (!atcButton) return;

  var grid = popup.querySelector('[data-exclusive-upsell-grid]');
  var bar = popup.querySelector('[data-exclusive-upsell-bar]');
  var hasProducts = popup.getAttribute('data-has-products') === 'true';

  var bypassIntercept = false;
  var CLOSE_TRANSITION_MS = 320;
  var closeTimer = null;

  function openPopup() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    popup.hidden = false;
    // Force layout so the browser registers the closed state before the
    // "is-open" class flips, otherwise the slide-up transition gets skipped.
    void popup.offsetHeight;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    document.body.classList.add('exclusive-upsell-popup-open');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.body.classList.remove('exclusive-upsell-popup-open');
    closeTimer = setTimeout(function () {
      popup.hidden = true;
      closeTimer = null;
    }, CLOSE_TRANSITION_MS);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function bindCard(card) {
    var toggleBtn = card.querySelector('[data-exclusive-upsell-toggle]');
    if (!toggleBtn) return;
    toggleBtn.addEventListener('click', function () {
      var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      completeAddToCart([variantId]);
    });
  }

  function buildCard(item) {
    var card = document.createElement('div');
    card.className = 'exclusive-upsell-card';
    card.setAttribute('data-exclusive-upsell-card', '');
    card.setAttribute('data-variant-id', item.variantId);
    card.innerHTML =
      '<div class="exclusive-upsell-card__image">' +
        '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="150" height="150">' +
      '</div>' +
      '<p class="exclusive-upsell-card__title">' + escapeHtml(item.title) + '</p>' +
      '<div class="exclusive-upsell-card__price">' +
        '<span class="exclusive-upsell-card__price-current">' + escapeHtml(item.price) + '</span>' +
        (item.compareAtPrice ? '<span class="exclusive-upsell-card__price-compare">' + escapeHtml(item.compareAtPrice) + '</span>' : '') +
      '</div>' +
      '<button type="button" class="exclusive-upsell-card__btn" data-exclusive-upsell-toggle>Add To Cart</button>';
    bindCard(card);
    return card;
  }

  function renderForVariant(variantData) {
    var metafields = (variantData && variantData.metafields) || {};
    var items = metafields.exclusiveUpsellProducts || [];
    hasProducts = items.length > 0;
    popup.setAttribute('data-has-products', hasProducts ? 'true' : 'false');
    popup.setAttribute('data-active-variant-id', variantData.id);

    if (grid) {
      grid.innerHTML = '';
      items.forEach(function (item) {
        if (!item || !item.variantId) return;
        grid.appendChild(buildCard(item));
      });
    }

    if (bar) {
      if (metafields.exclusiveBarText) {
        bar.textContent = metafields.exclusiveBarText;
        bar.hidden = false;
      } else {
        bar.textContent = '';
        bar.hidden = true;
      }
    }

    if (!hasProducts && popup.classList.contains('is-open')) {
      closePopup();
    }
  }

  popup.querySelectorAll('[data-exclusive-upsell-card]').forEach(bindCard);

  document.addEventListener('theme:variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !window.product || !window.product.variants) return;
    var variantData = window.product.variants.filter(function (v) {
      return v.id == variant.id;
    })[0];
    if (!variantData) return;
    renderForVariant(variantData);
  });

  popup.querySelectorAll('[data-exclusive-upsell-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  // Capture phase runs before the theme's own [data-add-to-cart] click handler
  // (bound on document in the bubble phase), so stopPropagation here fully
  // blocks the normal add-to-cart flow and shows the popup instead.
  document.addEventListener('click', function (e) {
    if (bypassIntercept || !hasProducts) return;
    var target = e.target.closest && e.target.closest('[data-add-to-cart]');
    if (target !== atcButton) return;
    e.preventDefault();
    e.stopPropagation();
    openPopup();
  }, true);

  var continueBtn = popup.querySelector('[data-exclusive-upsell-continue]');
  var loadingEl = popup.querySelector('[data-exclusive-upsell-loading]');

  var running = false;
  // Cart drawer refresh (network + render) can take a moment; cap how long
  // the spinner waits for it so the popup never gets stuck open.
  var LOADING_FALLBACK_MS = 8000;

  function setLoading(isLoading) {
    if (loadingEl) loadingEl.hidden = !isLoading;
    var buttons = popup.querySelectorAll('[data-exclusive-upsell-toggle], [data-exclusive-upsell-continue]');
    buttons.forEach(function (btn) {
      btn.disabled = isLoading;
    });
  }

  // Adds the given upsell variant ids (may be empty) plus the main product,
  // exactly as a normal Add to Cart click would.
  function completeAddToCart(upsellVariantIds) {
    if (running) return;
    running = true;
    setLoading(true);

    // Tag the upsell line with the parent's variant id so the cart drawer can
    // remove it automatically if the parent product is later removed.
    var parentIdInput = form.querySelector('input[name="id"]');
    var parentVariantId = parentIdInput ? parentIdInput.value : null;

    var items = (upsellVariantIds || []).map(function (variantId) {
      var item = { id: variantId, quantity: 1 };
      if (parentVariantId) {
        item.properties = { '_exclusive_upsell_parent': parentVariantId };
      }
      return item;
    });

    var addUpsells = items.length
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
      : Promise.resolve();

    addUpsells
      .catch(function (err) {
        console.error('[exclusive-upsell] failed to add upsell items', err);
      })
      .then(function () {
        // Let the theme's own add-to-cart handler add the main product and
        // open/refresh the cart drawer exactly as a normal click would.
        bypassIntercept = true;
        atcButton.click();
        bypassIntercept = false;

        var finished = false;
        var fallbackTimer = setTimeout(finish, LOADING_FALLBACK_MS);

        function finish() {
          if (finished) return;
          finished = true;
          clearTimeout(fallbackTimer);
          document.removeEventListener('theme:cart:added', finish);
          setLoading(false);
          closePopup();
          running = false;
        }

        // Fires once the cart drawer has actually finished rebuilding, so the
        // spinner stays up for the full duration instead of just our own fetch.
        document.addEventListener('theme:cart:added', finish);
      });
  }

  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      // "No thanks" skips every upsell and adds only the main product.
      completeAddToCart([]);
    });
  }
});
